module.exports = __webpack_public_path__ + "static/media/mario-hat.3333885d.svg";